import * as yup from 'yup'

export function canValidate(length: number, countryCode: string): boolean {
    if (countryCode === '+61') {
        return length >= 11
    }
    return length >= 10
}

export function validateMobileNumber(value: string, countryCode: string): { valid: boolean; message?: string } {
    if (!value) {
        return { valid: false, message: 'Please enter your mobile number' }
    }

    const cleanedValue = value.replace(/\D/g, '').replace(/^0/, '')
    const australiaRegex = /^4\d{8}$/
    const newZealandRegex = /^2\d{7,8}$/

    if (countryCode === '+61') {
        if (cleanedValue.length < 9) {
            return {
                valid: false,
                message: "You've entered fewer than 9 digits. Please review your mobile number and try again.",
            }
        } else if (!australiaRegex.test(cleanedValue)) {
            return {
                valid: false,
                message: 'Please enter a valid Australian mobile number in this format: (+61) 4XX XXX XXX.',
            }
        }
    } else if (countryCode === '+64') {
        if (cleanedValue.length < 8) {
            return {
                valid: false,
                message: "You've entered fewer than 8 digits. Please review your mobile number and try again.",
            }
        } else if (!newZealandRegex.test(cleanedValue)) {
            return {
                valid: false,
                message: 'Please enter a valid New Zealand mobile number in this format: (+64) 2X XXX XXXX',
            }
        }
    } else {
        return { valid: false, message: 'Unsupported country code' }
    }

    return { valid: true }
}

/**
 * Creates a yup validator for mobile number fields.
 *
 * Validates mobile number format based on country code (+61 for Australia, +64 for New Zealand).
 * This validator should be used in conjunction with a countryCode field in the same schema.
 *
 * @example
 * const schema = yup.object({
 *   countryCode: yup.string().required(),
 *   mobile: createMobileValidator()
 * })
 */
export function createMobileValidator() {
    return yup
        .string()
        .trim()
        .required('Please enter your mobile number')
        .test('mobile-validation', 'Invalid mobile number', function (this: any, value: string) {
            const { countryCode } = this.parent
            const validation = validateMobileNumber(value || '', countryCode)
            if (!validation.valid) {
                return this.createError({ message: validation.message })
            }
            return true
        })
}
